import { YnEnum } from './common.enums';

export const ProductDetailResultTypeAndMessage = {
    DEFAULT: '',
    SUCCESS: '제품 코드가 올바르게 입력되었습니다.',
    NOTFOUND: '존재하지 않는 제품 코드입니다.',
    ALREADYISSUED: '이미 인증서가 발행된 제품 코드입니다.',
    DISPOSED: '폐기된 제품입니다.',
    DUPLICATED: '중복되는 제품코드가 있습니다. 다시 확인해주세요.'
}

export const CertifiedCompanies = {
    default: {
        name: '',
        iconUrl: '',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%2FDefault.png',
        colorCode: '#F1F2F3',
    },
    dentium: {
        name: '덴티움',
        iconUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_round%252FDentium.svg',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%252FDentium.png',
        colorCode: '#EAF1C5',
    },
    dentis: {
        name: '덴티스',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%2FDefault.png',
        colorCode: '#C7CCD1',
    },
}

export const SurfaceCompanies = {
    plasmapp: {
        name: '플라즈맵',
        iconUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%252FPlasmapp.png',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%252FPlasmapp.png',
        colorCode: '#DED9F2',
    },
}

export const NotCertifiedCompanies = {
    default: {
        name: '',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%2FDefault.png',
        colorCode: '#F1F2F3',
    },
    dio: {
        name: '디오',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%2FDefault.png',
        colorCode: '#F1F2F3',
    },
    megazen: {
        name: '메가젠',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%2FDefault.png',
        colorCode: '#F1F2F3',
    },
    osstem: {
        name: '오스템',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%2FDefault.png',
        colorCode: '#F1F2F3',
    },
    neo: {
        name: '네오',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%2FDefault.png',
        colorCode: '#F1F2F3',
    },
    straumann: {
        name: '스트라우만',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%2FDefault.png',
        colorCode: '#F1F2F3',
    },
    etc: {
        name: '기타',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%2FDefault.png',
        colorCode: '#F1F2F3',
    }
}

/* 
    치아 객체 일종의 enum
    proxy object의 동작 방식이 특이하여 객체의 depth를 최소화함
*/

export const toothObject = {
    isCertified: null, // 인증제조사인지 아닌지, boolean
    toothNum: 0, // 치아번호

    
    resultMessage: ProductDetailResultTypeAndMessage.default,
    sentPushRequest: false,
    timer: null,
    pushId: '',
    sizeFirst: '', // deprecate 예정
    sizeSecond: '', // deprecate 예정
    hasCustomCompanyName: false, // deprecate 예정
    customCompanyName: '', // deprecate 예정
    
    // 표면처리 UI 관련
    didSurfaceProcess: false, // 표면처리 선택 여부
    isSurfaceListShowing: false, // 드롭다운 목록 노출 여부(커스텀 드롭다운)
    surfaceProcessText: '별도의 표면 처리가 적용되지 않았습니다.',  // 표면처리 문구
    // 표면처리 데이터 관련
    surfaceImageUrl: '', // 표면처리 제품 이미지 url
    isPlasmapp: false, // 플라즈맵인지 여부. 더 이상 안 쓰는 값 같음(probably deprecate 예정)
    surfaceItemId: '', // 표면처리 품목 ID
    surfaceItemName: '', // 표면처리 품목명
    surfaceProductCode: '', // 표면처리 제품 코드
    surfaceNftIssueCount: '', // 발행 횟수(~회 사용)
    // 공통정보
    group: CertifiedCompanies.dentium.name, // 회사명(아마 비즈메시지용 변수)
    itemName: '', // 품목명
    metadataInfo: { // 클립용 메타데이터
        attributes: [], // 클립 설명란 하단에 들어가는 항목들
        background_color: CertifiedCompanies.dentium.colorCode, // 클립앱 NFT목록에서 나오는 배경색
        description: '', // 제목 아래 나오는 설명
        group_name: CertifiedCompanies.dentium.name, // 회사명(클립용 변수)
        image: CertifiedCompanies.dentium.imgUrl, // 이미지 url
        name: '', // 클립에서 보여줄 NFT 제목
    },

    // 인증제조사 중 제품코드로 입력할 때 받는 정보 
    itemCode: '', // 품목 코드
    productCode: '', // 제품 코드
    productId: '', // 제품 ID
    productType: '', // 제품 타입(치아 임플란트 등)

    duplicateYn: YnEnum.Y, // 중복 허용 여부

    // 치아제품목록에서 선택
    selectedDentItemStepOne: '', // 제조사
    selectedDentItemStepTwo: '', // 브랜드
    selectedDentItemStepThree: '', // 사양
    
    // 인증제조사인데 커스텀값, 제조사는 현재 하나여서 없음
    selectedCustomCertifiedDentItemStepTwo: '', // 브랜드
    selectedCustomCertifiedDentItemStepThree: '', // 사양
    
    // 인증제조사가 아닌데 커스텀값
    selectedCustomDentItemStepOne: '',  // 제조사
    selectedCustomDentItemStepTwo: '',  // 브랜드
    selectedCustomDentItemStepThree: '',  // 사양

    dentItemStepOne: { // 
        dentium: [],
        other: [],
    },
    dentItemStepTwo: {
        title: '제품명',
        list: [],
    },
    dentItemStepThree: {
        title: '제품 사양',
        list: [],
    },
    dentItemStepOneList: [],

    // 클릭클릭 관련
    willTypeProductCode: false, // 제품코드 직접 입력 여부
    willTypeCertifiedProductInfoTwo: false, // 인증제조사 브랜드 직접입력 여부
    willTypeCertifiedProductInfoThree: false, // 인증제조사 사양 직접입력 여부
    willTypeNotCertifiedProductInfoOne: false, // 미인증제조사명 직접입력 여부
    willTypeNotCertifiedProductInfoTwo: false, // 미인증제조사 브랜드 직접입력 여부
    willTypeNotCertifiedProductInfoThree: false, // 미인증제조사 사양 직접입력 여부
}

export function createToothObject() {
    return toothObject;
}

export const DentItemCompanies = { // 치아 제조사 호출용 enum
    DENTIUM: '덴티움',
    OTHER: 'other'
}